<div class="legend-value total" [ngClass]="status">
  <span class="legend">Total Amount</span>
  <span class="value">
    <app-monetary-value [value]="amountDue / 100"></app-monetary-value>
  </span>
</div>
<hr />
<div class="legend-value balance" [ngClass]="status">
  <span class="legend">Still to Pay</span>
  <span class="value">
    @if (!confirmationPending) {
      <app-monetary-value [value]="balance / 100"> </app-monetary-value>
    }
    @if (confirmationPending) {
      <div class="pending-confirmation">
        <app-slip-component-status class="still-to-pay-status" [status]="'pending'"></app-slip-component-status>
      </div>
    }
  </span>
</div>
<hr />
@if (statusReason && !processingPayment) {
  <div>
    <app-slip-component-status-reason
      [iconSrc]="statusReason.iconSrc"
      [heading]="statusReason.heading"
    [message]="statusReason.message"></app-slip-component-status-reason>
  </div>
}
